(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.hh-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  function initRails(root) {
    (root || document).querySelectorAll('[data-hh-rail]').forEach(function (rail) {
      var wrap = rail.parentElement;
      var prev = wrap.querySelector('[data-hh-prev]');
      var next = wrap.querySelector('[data-hh-next]');
      var step = function () { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; };
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { var v = e.target.querySelector('video'); if (!v) return; if (e.isIntersecting) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } });
        }, { threshold: 0.4 });
        rail.querySelectorAll('.hh-media').forEach(function (m) { vio.observe(m); });
      }
    });
  }
  function init(root) { initReveal(root); initRails(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); e.target.querySelectorAll('.hh-reveal').forEach(function (el) { el.classList.add('is-in'); }); });
})();

/* Koszyk: „Rabaty zarezerwowane przez następne 15 minut” – liczy od dodania do koszyka, nie resetuje się po odświeżeniu */
(function () {
  var MS = 15 * 60 * 1000, KS = 'hhResStart', KC = 'hhResCount';
  var get = function (k) { try { return Number(localStorage.getItem(k)) || 0; } catch (e) { return 0; } };
  var put = function (k, v) { try { localStorage.setItem(k, String(v)); } catch (e) {} };
  var del = function (k) { try { localStorage.removeItem(k); } catch (e) {} };
  var tick = function () {
    var boxes = document.querySelectorAll('[data-hh-res]');
    if (!boxes.length) return;
    var count = Number(boxes[0].dataset.count) || 0;
    var now = Date.now(), start = get(KS), prev = get(KC);
    if (count === 0) { del(KS); del(KC); return; }
    // start przy pierwszym dodaniu; nowy start, gdy czas minął, a klient dorzucił coś do koszyka
    if (!start || (count > prev && now - start >= MS)) { start = now; put(KS, start); }
    if (count !== prev) put(KC, count);
    var left = Math.max(0, MS - (now - start));
    var s = Math.ceil(left / 1000), txt = Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
    boxes.forEach(function (b) {
      var t = b.querySelector('[data-hh-res-left]'); if (t && t.textContent !== txt) t.textContent = txt;
      var bar = b.querySelector('[data-hh-res-bar]'); if (bar) bar.style.width = (left / MS * 100).toFixed(2) + '%';
      b.classList.toggle('is-low', left < 3 * 60 * 1000);
    });
  };
  tick();
  setInterval(tick, 1000);
})();
